module.exports = __webpack_public_path__ + "img/sTwinkleIc_193x205.f623298f.png";